import React from 'react';
import { Modal, Typography, Row, Col, Button } from 'antd';
import { FileOutlined, WhatsAppOutlined, ClockCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import LegalChileLogo from '../../images/legalchile.svg';
import TramittaLogo from '../../images/tramitta-logo.png';

const { Title, Text } = Typography;

const WelcomeForm = ({ visible, close }) => {
  return (
    <Modal
      visible={visible}
      okText="Entendido"
      maskClosable={true}
      closable={false}
      centered
      width={636}
      footer={null}
    >
      <Row className="my-5 pt-3">
        <Col xs={22} sm={16} className="mx-auto">
          <Title level={2} className="text-center fw-bold">
            Crea un nuevo contrato de arriendo
          </Title>
        </Col>
      </Row>
      <Row gutter={16} className="justify-content-center mb-4 pb-3">
        <Col className="gutter-row" xs={3} sm={2}>
          <FileOutlined style={{color: '#41ebba', fontSize:'2rem'}} />
        </Col>
        <Col className="gutter-row" span={16}>
          <Text>Ahora ingresa los datos requeridos para generar tu contrato de arriendo. En todo momento podrás revisar cómo va quedando tu contrato.</Text>
        </Col>
      </Row>
      <Row gutter={16} className="justify-content-center mb-4 pb-3">
        <Col className="gutter-row" xs={3} sm={2}>
          <WhatsAppOutlined style={{color: '#ffb400', fontSize:'2rem'}} />
        </Col>
        <Col className="gutter-row" span={16}>
          <Text>Si tienes dudas o quieres agregar cláusulas al contrato, puedes contactarnos por Whatsapp pinchando el botón de la derecha.</Text>
        </Col>
      </Row>
      <Row gutter={16} className="justify-content-center mb-5 pb-3">
        <Col className="gutter-row" xs={3} sm={2}>
          <ClockCircleOutlined style={{color: '#2300ff', fontSize:'2rem'}} />
        </Col>
        <Col className="gutter-row" span={16}>
          <Text>La creación del contrato te tomará entre 15 a 20 minutos. Podrás guardar tu progreso y continuar en otro momento.</Text>
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Button type="primary" onClick={close} style={{height: '50px'}}  className="px-5" >Entendido</Button>
      </Row>
      <Row gutter={48} className="justify-content-center mb-5">
        <Col>
          <img src={LegalChileLogo} alt="" width="162" className="legal-logo" />
        </Col>
        <Col>
          <img src={TramittaLogo} alt="" width="108" className="tramitta-logo" />
        </Col>
      </Row>
    </Modal>
  );
};

WelcomeForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default WelcomeForm;
